import { Popover } from "@molecules/index"

import { SidePanelProps } from "./SidePanel.types"
import SidePanelBody from "./SidePanelBody/SidePanelBody"
import SidePanelContent from "./SidePanelContent/SidePanelContent"
import SidePanelFilePreview from "./SidePanelFilePreview/SidePanelFilePreview"
import SidePanelNavigation from "./SidePanelNavigation/SidePanelNavigation"
import SidePanelPanel from "./SidePanelPanel/SidePanelPanel"

function SidePanel(props: SidePanelProps) {
    const { children, isOpen, onOpenChange } = props

    return (
        <Popover.Root
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            isAnchored={false}
            isDismissable={false}
            hasDragIndicator={false}
        >
            {children}
        </Popover.Root>
    )
}

const Root = SidePanel
const Content = SidePanelContent
const Panel = SidePanelPanel
const Body = SidePanelBody
const FilePreview = SidePanelFilePreview

// Optional navigation zone between header and body; see SidePanelNavigation for usage.
const Navigation = SidePanelNavigation.Root
const NavigationRow = SidePanelNavigation.Row

function Trigger(props: React.ComponentProps<typeof Popover.Trigger>) {
    return <Popover.Trigger {...props} />
}

function Close(props: React.ComponentProps<typeof Popover.Close>) {
    return <Popover.Close {...props} />
}

export default { Root, Content, Panel, Body, FilePreview, Navigation, NavigationRow, Trigger, Close }
